export enum DataKey {
  PitchNo = 'playSequenceNumber',
  Pitcher = 'pitcher',
  Catcher = 'catcher',
  Batter = 'batter',
  Balls = 'balls',
  Strikes = 'strikes',
  Outs = 'outs',
  Inning = 'inning',
  PitcherDexterity = 'pitcherDexterity',
  BatterDexterity = 'batterDexterity',
  TaggedPitchType = 'taggedPitchType',
  PitchCall = 'pitchCall',
  HitType = 'hitType',
  PlayResult = 'playResult',
  OutsOnPlay = 'outsOnPlay',
  RunsScored = 'runsScored',
  VerticalReleaseAngle = 'verticalReleaseAngle',
  HorizontalReleaseAngle = 'horizontalReleaseAngle',
  SpinRate = 'spinRate',
  SpinAxis = 'spinAxis',
  Extension = 'extension',
  VerticalBreak = 'verticalBreak',
  HorizontalBreak = 'horizontalBreak',
  IsWarmup = 'isWarmup',
  KOrBB = 'korbb',
  ReleaseSpeed = 'releaseSpeed',
  Tilt = 'tilt',
  ReleaseHeight = 'releaseHeight',
  ReleaseSide = 'releaseSide',
  InducedVerticalBreak = 'inducedVerticalBreak',
  PlateLocHeight = 'plateLocHeight',
  PlateLocSide = 'plateLocSide',
  HitExitSpeed = 'hitExitSpeed',
  HitEstCarry = 'hitEstCarry',
  HitDirection = 'hitDirection',
  HitBearing = 'hitBearing',
  ChangedValues = 'changedValues',
  TrackStartTimeLocal = 'trackStartTimeLocal',
}
